/**
 * Light haptic feedback for key actions (PD-14695).
 *
 * Deliberately sparse — payment success, filter preset selection,
 * pull-to-refresh trigger, sign-in success, biometric enrollment.
 * Haptics on every tap reads as noise, so think hard before adding a
 * call site.
 *
 * No-op on web: the platform check short-circuits before the plugin is
 * ever imported, so the browser bundle never loads @capacitor/haptics
 * and web behavior is unchanged. Failures are swallowed — feedback is
 * garnish, never load-bearing.
 */

function isNativePlatform(): boolean {
	return (
		typeof window !== 'undefined' &&
		(
			window as { Capacitor?: { isNativePlatform?: () => boolean } }
		).Capacitor?.isNativePlatform?.() === true
	);
}

/** Fire a single light impact tap. Safe to call from any event handler. */
export function triggerLightImpact(): void {
	if (!isNativePlatform()) {
		return;
	}
	void import('@capacitor/haptics')
		.then((mod) => mod.Haptics.impact({ style: mod.ImpactStyle.Light }))
		.catch(() => {
			// Plugin unavailable (older shell binary) — silently skip.
		});
}
